import React from 'react';
import { FormikRadioInput as Radio } from '@front-activerse/common-components';
import { useTranslator } from '@front-activerse/common-components';

export const Sex: React.FC = () => {
  const { t } = useTranslator();

  return (
    <>
      <h2 className="mb-4 title-large semi-bold">
        {t('app.nutritionSettings.dietVersion.headline')}
      </h2>

      <Radio name="dietVariant" value="FAST_AND_MIXED">
        <strong>{t('app.nutritionSettings.dietVersion.quickWorld.title')}</strong>
        <p className="mb-0">{t('app.nutritionSettings.dietVersion.quickWorld.description')}</p>
      </Radio>

      <Radio name="dietVariant" value="ENGAGING_AND_MIXED">
        <strong>{t('app.nutritionSettings.dietVersion.engagingWorld.title')}</strong>
        <p className="mb-0">{t('app.nutritionSettings.dietVersion.engagingWorld.description')}</p>
      </Radio>

      <Radio name="dietVariant" value="FAST_AND_TRADITIONAL">
        <strong>{t('app.nutritionSettings.dietVersion.quickTraditional.title')}</strong>
        <p className="mb-0">
          {t('app.nutritionSettings.dietVersion.quickTraditional.description')}
        </p>
      </Radio>

      <Radio name="dietVariant" value="ENGAGING_AND_TRADITIONAL">
        <strong>{t('app.nutritionSettings.dietVersion.engagingTraditional.title')}</strong>
        <p className="mb-0">
          {t('app.nutritionSettings.dietVersion.engagingTraditional.description')}
        </p>
      </Radio>
    </>
  );
};

export default Sex;
